const Footer = props => {
    return(
        <footer className="footer">
            <div className="grid">
                <div className="blue card"></div>
                <div className="red card"></div>
                <div className="orange card"></div>
                <div className="green card"></div>
            </div>
            <div className="footer-content">
                <p>&copy;2018 BANKCODE | Privacy Policy | Terms of Service | System Requirements | All Rights Reserved</p>
            </div>
        </footer>
    )
}

export default Footer;